import React from 'react'

const PrivacyPolicy = () => {
    return (
        <div className="min-h-screen pt-24 pb-20">
            <section className="bg-gradient-to-br from-emerald-800 to-emerald-900 text-white py-20">
                <div className="container mx-auto px-4">
                    <div className="max-w-3xl mx-auto text-center">
                        <h1 className="text-5xl font-bold mb-6">
                            Privacy Policy
                        </h1>
                        <p className="text-xl text-emerald-50">
                            Last Updated: December 2025
                        </p>
                    </div>
                </div>
            </section>

            <section >

                <main className="p-8 md:p-12 lg:p-16">
                    <section className="prose prose-slate max-w-none flex flex-col gap-6">
                        <article id="cover">
                            <h3 className="text-3xl font-bold text-emerald-900 mb-6">1. What This Document Covers</h3>
                            <p>
                                This policy explains: what information <strong>Mojo Money (the App)</strong> collects, how we use and protect your
                                data, and your rights and choices.
                            </p>
                        </article>


                        <hr />


                        <article id="collect">
                            <h3 className="text-3xl font-bold text-emerald-900 mb-6 ">2. Information We Collect</h3>
                            <p>Mojo Money only collects what’s necessary to run the app securely and reliably:</p>
                            <ul>
                                <li><strong>Account Info</strong>: Name, email, and phone number.</li>
                                <li><strong>Payment Info</strong>: Card details processed securely by partners like Stripe/PayPal (we never store your full card number).</li>
                                <li><strong>Usage Data</strong>: Device type, IP address — used to prevent fraud and improve functionality.</li>
                            </ul>
                        </article>


                        <hr />


                        <article id="use">
                            <h3 className="text-3xl font-bold text-emerald-900 mb-6">3. How We Use Your Data</h3>
                            <ul>
                                <li>To process payments and keep your account secure.</li>
                                <li>To improve the app and fix bugs.</li>
                                <li>To prevent fraud.</li>
                                <li><strong>We never sell your data.</strong></li>
                            </ul>
                        </article>


                        <hr />


                        <article id="share">
                            <h3 className="text-3xl font-bold text-emerald-900 mb-6">4. Data Sharing</h3>
                            <ul>
                                <li>With payment partners to complete transactions.</li>
                                <li>With law enforcement when required by law.</li>
                                <li>With your consent for specific features.</li>
                            </ul>
                        </article>


                        <hr />


                        <article id="rights">
                            <h3 className="text-3xl font-bold text-emerald-900 mb-6">5. Your Rights</h3>
                            <ul>
                                <li>Request access or deletion of your data at <a href="mailto:support@mojomoneyeth.com">support@mojomoneyeth.com</a>.</li>
                                <li>Opt out of marketing emails via the unsubscribe link.</li>
                                <li>Disable permissions (e.g., location) in your device settings.</li>
                            </ul>
                        </article>


                        <hr />


                        <article id="security">
                            <h3 className="text-3xl font-bold text-emerald-900 mb-6">6. Security</h3>
                            <ul>
                                <li>Bank‑level TLS/SSL encryption.</li>
                                <li>Regular vulnerability checks.</li>
                                <li>Strict internal access controls.</li>
                            </ul>
                        </article>


                        <hr />


                        <article id="changes">
                            <h3 className="text-3xl font-bold text-emerald-900 mb-6">7. Changes to This Policy</h3>
                            <p>We will notify you via email or app alerts whenever this policy is updated. Continued use of the app means you accept those changes.</p>
                        </article>


                        <hr />


                        <article id="contact">
                            <h3 className="text-3xl font-bold text-emerald-900 mb-6">8. Contact Us</h3>
                            <p><strong>Email:</strong> <a href="mailto:support@mojomoneyeth.com">support@mojomoneyeth.com</a></p>
                            <p><strong>Address:</strong><br />8 South Jordan Street<br />Alexandria, Virginia 22304</p>
                        </article>


                        <hr />


                        <footer className="mt-8 py-6 text-sm text-gray-500">
                            <p>© {new Date().getFullYear()} Mojo Money. All rights reserved.</p>
                        </footer>
                    </section>
                </main>
            </section>
        </div>
    )
}

export default PrivacyPolicy
